import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';

@Component({
    selector: 'app-resource-details-ecourse',
    templateUrl: './resource-details-ecourse.component.html',
    styleUrls: ['./resource-details-ecourse.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsEcourseComponent extends ResourceDetailsBaseComponent {
    constructor() {
        super();
    }
}
